import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ConfirmDialog from "../components/ConfirmDialog";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { getErrorString } from "../display/ErrorStrings";
import { BUILD_NUMBER } from "../components/Constants";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    const root = document.getElementById("root");
    const loginTitle = root.getAttribute("login_page_title");
    const loginToolbarColor = root.getAttribute("login_page_toolbar_color");
    const loginRealmStatic = root.getAttribute("login_page_realm");

    this.state = {
      userName: "",
      userPassword: "",
      userRealm: "",
      newPassword: "",
      confirmNewPassword: "",
      activationKey: "",
      dfaKey: "",
      actionType: 0,
      errorString: "",
      submitDisabled: false,
      loginTitle: loginTitle,
      loginToolbarColor: loginToolbarColor,
      loginRealmStatic: loginRealmStatic,
      confirmLogoutSession: false,
    };
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleRealmChange = this.handleRealmChange.bind(this);
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.handleConfirmNewPasswordChange = this.handleConfirmNewPasswordChange.bind(
      this
    );
    this.handleActivationKeyChange = this.handleActivationKeyChange.bind(this);
    this.handleDfaKeyChange = this.handleDfaKeyChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter" && !this.state.submitDisabled) {
      e.preventDefault();
      e.stopPropagation();
      this.handleFormSubmit(e);
    }
  };
  handleUserNameChange(e) {
    this.setState({ userName: e.target.value });
    this.setState({ errorString: "" });
  }
  handlePasswordChange(e) {
    this.setState({ userPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleRealmChange(e) {
    this.setState({ userRealm: e.target.value });
    this.setState({ errorString: "" });
  }
  handleNewPasswordChange(e) {
    this.setState({ newPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleConfirmNewPasswordChange(e) {
    this.setState({ confirmNewPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleActivationKeyChange(e) {
    this.setState({ activationKey: e.target.value });
    this.setState({ errorString: "" });
  }
  handleDfaKeyChange(e) {
    this.setState({ dfaKey: e.target.value });
    this.setState({ errorString: "" });
  }

  handleLogout(e, action) {
    e.preventDefault();
    this.setState({ confirmLogoutSession: false });
    if (action === 1) {
      fetch("on_logout_force", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: this.state.userName,
          realm: this.state.userRealm,
          r: new Date().getTime(),
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          if (window.sco_return_url) {
            window.location.href = window.sco_return_url;
          } else {
            this.props.history.push("/");
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
      this.setState({
        errorString: getErrorString(
          "user.login.retry",
          "Your existing session was disconnected. Please login."
        ),
      });
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (this.state.actionType === 0) {
      if (this.state.userName == null || this.state.userName === "") {
        this.setState({
          errorString: getErrorString(
            "login.username.error",
            "User Name is required"
          ),
        });
        return;
      }
      if (this.state.userPassword == null || this.state.userPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.password.error",
            "Password is required"
          ),
        });
        return;
      }
      if (this.state.userRealm == null || this.state.userRealm === "") {
        this.setState({
          errorString: getErrorString("login.realm.error", "Realm is required"),
        });
        return;
      }
    } else if (this.state.actionType === 1) {
      if (this.state.userPassword == null || this.state.userPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.oldpassword.error",
            "Old Password is required."
          ),
        });
        return;
      }
      if (this.state.newPassword == null || this.state.newPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.newpassword.error",
            "New Password is required."
          ),
        });
        return;
      }
      if (
        this.state.confirmNewPassword == null ||
        this.state.confirmNewPassword === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.confirmpassword.error",
            "Confirm Password is required."
          ),
        });
        return;
      }
      if (this.state.newPassword.length < 8) {
        this.setState({
          errorString: getErrorString(
            "login.passwordLength.error",
            "New Password must be at least 8 characters."
          ),
        });
        return;
      }
      if (this.state.confirmNewPassword !== this.state.newPassword) {
        this.setState({
          errorString: getErrorString(
            "login.passwordNotMatch.error",
            "New and Confirm Passwords do not match."
          ),
        });
        return;
      }
    } else if (this.state.actionType === 2) {
      if (this.state.activationKey == null || this.state.activationKey === "") {
        this.setState({
          errorString: getErrorString(
            "login.activationKey.error",
            "Activation Key is required."
          ),
        });
        return;
      }
    } else if (this.state.actionType === 3) {
      if (this.state.dfaKey == null || this.state.dfaKey === "") {
        this.setState({
          errorString: getErrorString(
            "login.dfaKey.error",
            "Dual-Factor Authentication Key is required."
          ),
        });
        return;
      }
    }
    this.setState({ confirmLogoutSession: false });
    this.setState({ errorString: "" });
    this.setState({ submitDisabled: true });
    fetch("on_login", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        actionType: this.state.actionType,
        userName: this.state.userName,
        password: this.state.userPassword,
        realm: this.state.userRealm,
        newPassword: this.state.newPassword,
        activationKey: this.state.activationKey,
        dfaKey: this.state.dfaKey,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.error === true) {
          if (
            getErrorString(
              "user.login.access.denied",
              "Access denied! This user is currently logged in."
            ) === reply.errorString
          ) {
            this.setState({ confirmLogoutSession: true });
            this.setState({ errorString: reply.errorString });
            this.setState({ submitDisabled: false });
          } else {
            this.setState({ errorString: reply.errorString });
            this.setState({ submitDisabled: false });
          }
        } else if (reply.warning === true) {
          this.setState({ submitDisabled: false });
          if ("change_password" === reply.warningString) {
            this.setState({ userPassword: "" });
            this.setState({ actionType: 1 });
          } else if ("activate" === reply.warningString) {
            this.setState({ actionType: 2 });
          } else if ("dfa" === reply.warningString) {
            this.setState({ actionType: 3 });
          } else {
            this.setState({
              errorString:
                "Unexpected service reply. Please contact your system administrator",
            });
            this.setState({ submitDisabled: false });
          }
        } else {
          this.props.history.push({
            pathname: "/enter",
            state: {
              secureToken: reply.secureToken,
              lastLogin: reply.lastLogin,
              isReadOnly: false,
            },
          });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ submitDisabled: false });
      });
  }

  render() {
    return (
      <div>
        {this.state.confirmLogoutSession && (
          <ConfirmDialog
            title="Another user session is active."
            text="Are you sure you want to disconnect the existing user session?"
            onCloseConfirm={this.handleLogout}
          />
        )}
        <AppBar
          position="static"
          style={{ background: this.state.loginToolbarColor }}
        >
          <Toolbar>
            <img
              src="login_logo.png"
              alt="Bank logo"
              style={{ maxWidth: "140px", maxHeight: "60px" }}
            />
            {/* <Typography variant="h6" color={"inherit"} >
            {APPNAME}   
          </Typography> */}
          </Toolbar>
        </AppBar>

        <Dialog open fullScreen={this.props.fullScreen}>
          <DialogTitle>
            {this.state.actionType === 0
              ? this.state.loginTitle
              : this.state.actionType === 1
              ? "Change Your Password"
              : this.state.actionType === 1
              ? "Activate Your Account"
              : "Dual-Factor Authentication"}
          </DialogTitle>
          <div
            onKeyPress={(e: KeyboardEvent<HTMLDivElement>) =>
              this.handleKeyPress(e)
            }
          >
            {this.state.actionType === 0 && (
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="User Name"
                  type="text"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleUserNameChange}
                />
                <TextField
                  margin="dense"
                  id="password"
                  label="Password"
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handlePasswordChange}
                />
                <TextField
                  margin="dense"
                  id="realm"
                  label={this.state.loginRealmStatic}
                  type="text"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleRealmChange}
                />
              </DialogContent>
            )}

            {this.state.actionType === 1 && (
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="oldPass"
                  label="Current Password"
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handlePasswordChange}
                />
                <TextField
                  margin="dense"
                  id="newPass"
                  label="New Password"
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleNewPasswordChange}
                />
                <TextField
                  margin="dense"
                  id="confirmNewPass"
                  label="Confirm Password"
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleConfirmNewPasswordChange}
                />
              </DialogContent>
            )}

            {this.state.actionType === 2 && (
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="actKey"
                  label="Activation Key"
                  type="text"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleActivationKeyChange}
                />
              </DialogContent>
            )}

            {this.state.actionType === 3 && (
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="dfaKey"
                  label="Dual-Factor Authentication Key"
                  type="text"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handleDfaKeyChange}
                />
              </DialogContent>
            )}
          </div>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.handleFormSubmit}
              color="primary"
              disabled={this.state.submitDisabled}
            >
              Submit
            </Button>
          </DialogActions>
          {this.state.errorString.length > 0 && (
            <Typography
              style={{ fontSize: 16, paddingLeft: 10 }}
              color="error"
              variant="body1"
            >
              {" "}
              {getErrorString("general.error", "ERROR: ") +
                this.state.errorString}
            </Typography>
          )}
          {this.state.actionType === 0 && (
            <Typography
              style={{ fontSize: 16, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              If you have forgotten your password,
              <br />
              please contact your system Administrator to have it reset.
            </Typography>
          )}
          {this.state.actionType === 1 && (
            <Typography
              style={{ fontSize: 16, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              You are required to change your password at this time.
              <br />
              New password must be minimum 8 characters <br />
              with at least one digit, one letter and one special character.
            </Typography>
          )}
          {this.state.actionType === 2 && (
            <Typography
              style={{ fontSize: 16, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              Please contact your system Administrator if you do not have an
              activation key.
            </Typography>
          )}
          {this.state.actionType === 3 && (
            <Typography
              style={{ fontSize: 16, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              Please contact your system Administrator if you do not receive a
              dual-factor authentication key by email.
            </Typography>
          )}
          <br></br>
          <Typography
            style={{ fontSize: 16, paddingLeft: 10 }}
            color="primary"
            variant="body1"
          >
            {BUILD_NUMBER}
          </Typography>
        </Dialog>
      </div>
    );
  }
}

export default LoginForm;
